import { ref, computed } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
import Empty from '@/components/Empty.vue';
import CustomNameCell from './CustomNameCell.vue';
import QueryTimeCell from './QueryTimeCell.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProductTable',
  props: {
    list: null,
    loading: {
      type: Boolean
    },
    selectedRowKeys: null,
    pageIndex: null,
    pageSize: null,
    total: null
  },
  emits: ["update:selectedRowKeys", "page-change", "save-name", "save-time"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    /** 同一时刻只允许一个自定义商品名单元格处于编辑态 */
    const editingProductId = ref('');
    const columns = [{
      title: '产品名称',
      dataIndex: 'productName',
      key: 'productName',
      width: 220,
      ellipsis: true
    }, {
      title: '商品名',
      dataIndex: 'storeName',
      key: 'storeName',
      width: 220,
      ellipsis: true
    }, {
      title: '自定义商品名',
      dataIndex: 'customName',
      key: 'customName',
      width: 240
    }, {
      title: '可查询时间',
      dataIndex: 'queryTime',
      key: 'queryTime'
    }];
    const pagination = computed(() => ({
      current: props.pageIndex,
      pageSize: props.pageSize,
      total: props.total,
      showSizeChanger: true,
      showTotal: total => `共 ${total} 条`
    }));
    const handleSelectChange = keys => {
      emit('update:selectedRowKeys', keys.map(String));
    };
    const handleTableChange = page => {
      emit('page-change', page.current || 1, page.pageSize || props.pageSize);
    };
    const handleSaveName = payload => {
      editingProductId.value = '';
      emit('save-name', payload);
    };
    const handleSaveTime = payload => {
      emit('save-time', payload);
    };
    return (_ctx, _cache) => {
      const _component_a_table = _resolveComponent("a-table");
      return _openBlock(), _createBlock(_component_a_table, {
        class: "product-table",
        "row-key": "productId",
        size: "middle",
        columns: columns,
        "data-source": __props.list,
        loading: __props.loading,
        scroll: {
          y: 'calc(100vh - 360px)'
        },
        "row-selection": {
          selectedRowKeys: __props.selectedRowKeys,
          onChange: handleSelectChange
        },
        pagination: _unref(pagination),
        onChange: handleTableChange
      }, {
        emptyText: _withCtx(() => [_createVNode(Empty, {
          description: "当前条件下暂无产品"
        })]),
        bodyCell: _withCtx(({
          column,
          record
        }) => [column.key === 'customName' ? (_openBlock(), _createBlock(CustomNameCell, {
          key: 0,
          product: record,
          editable: editingProductId.value === record.productId,
          onStartEdit: _cache[0] || (_cache[0] = id => editingProductId.value = id),
          onCancelEdit: _cache[1] || (_cache[1] = $event => editingProductId.value = ''),
          onSave: handleSaveName
        }, null, 8, ["product", "editable"])) : column.key === 'queryTime' ? (_openBlock(), _createBlock(QueryTimeCell, {
          key: 1,
          product: record,
          onSave: handleSaveTime
        }, null, 8, ["product"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["data-source", "loading", "scroll", "row-selection", "pagination"]);
    };
  }
});